<div class="card">
  <!-- Card Header -->
  <div class="px-4 py-3 border-b">
    <h3 class="text-lg font-semibold">Subscription Types</h3>
  </div>

  <!-- Card Body -->
  <div class="p-4">
    <kendo-grid
      [kendoGridBinding]="repState.subscriptions"
      [pageSize]="20"
      [pageable]="true"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <button
          type="button"
          icon="plus-outline"
          look="flat"
          kendoGridAddCommand
          class="mr-2 bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 transition"
        >
          Add New Record
        </button>
        <button
          type="button"
          icon="refresh-sm"
          look="flat"
          kendoButton
          class="bg-gray-200 dark:bg-gray-700 px-3 py-1 rounded hover:bg-gray-300 dark:hover:bg-gray-600 transition"
        >
          Refresh
        </button>
      </ng-template>

      <kendo-grid-column field="subscriptionDescription" title="Subscription" width="300">
        <ng-template kendoGridEditTemplate let-column="column" let-formGroup="formGroup">
          <input class="k-textbox k-adjust-width" [formControl]="formGroup.get(column.field)" maxlength="50" kendoTextBox />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="active" title="Active" width="50">
        <ng-template kendoGridCellTemplate let-column>
          <input type="checkbox" [checked]="column.active" disabled />
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup" let-column="column">
          <input type="checkbox" [formControl]="formGroup.get(column.field)" />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column title="Command" width="100">
        <ng-template kendoGridCellTemplate>
          <button kendoGridEditCommand [primary]="true" class="mr-1 bg-yellow-500 text-white px-2 py-1 rounded">Edit</button>
          <button kendoGridSaveCommand [disabled]="formGroup?.invalid" class="mr-1 bg-green-600 text-white px-2 py-1 rounded">Save</button>
          <button kendoGridCancelCommand class="bg-gray-400 text-white px-2 py-1 rounded">Cancel</button>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>

